import App from '@/models/App'

export default class ProfileMe extends App {
    static get entity() {
        return 'ProfileMe'
    }
    static one() {
        return this.query().withAllRecursive().get()
    }
    static fields() {
        return {
            id: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            firstNameEn: this.attr(''),
            middleNameEn: this.attr(''),
            lastNameEn: this.attr(''),
            profileImage: this.attr(''),
            email: this.attr(''),
            tel: this.attr(''),
            profileEmail: this.attr(''),
            profileTel: this.attr(''),
            companyName: this.attr(''),
            companyNameEn: this.attr(''),
            companyTel: this.attr(''),
            job: this.attr(''),
            companyWebsite: this.attr(''),
            department: this.attr(''),
            fax: this.attr(''),
            description: this.attr(''),
            isPublicProfile: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/users/me/profile`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            update(params) {
                return this.patch(`/users/me/profile`, App.patch(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
        },
    }
}
